var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_"},[_c('navbar'),_c('div',{staticClass:"breadcrum_"},[_vm._v("首页 > 联系我们")]),_c('div',{staticClass:"con_"},_vm._l((_vm.locList),function(item){return _c('div',{staticClass:"item_"},[_c('p',[_vm._v(_vm._s(item.tit))]),_c('p',[_vm._v(_vm._s(item.address))]),_c('p',[_vm._v("电话："+_vm._s(item.phone))])])}),0),_c('footbar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }